"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Stepper = exports.Step = void 0;

var _react = _interopRequireDefault(require("react"));

var _CheckIcon = require("../../svgs/CheckIcon");

var _ChevronIcon = require("../../svgs/ChevronIcon");

var _BaseTabs = require("../BaseTabs");

var _Box = require("../Box");

var _Clickable = require("../Clickable");

var _Flex = require("../Flex");

var _Tabs = require("../Tabs");

var _excluded = ["currentStepIndex", "disableNavigation", "initialTabIndex", "children"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/** Stepper */
var Stepper = function Stepper(_ref) {
  var currentStepIndex = _ref.currentStepIndex,
      disableNavigation = _ref.disableNavigation,
      _ref$initialTabIndex = _ref.initialTabIndex,
      initialTabIndex = _ref$initialTabIndex === void 0 ? 0 : _ref$initialTabIndex,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded);

  var _useTabs = (0, _Tabs.useTabs)({
    children: children,
    initialTabIndex: initialTabIndex
  }),
      tabs = _useTabs.tabs,
      activeTab = _useTabs.activeTab,
      activeTabIndex = _useTabs.activeTabIndex,
      handleClick = _useTabs.handleClick,
      ref = _useTabs.ref;

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_BaseTabs.BaseTabs, _extends({
    ref: ref,
    fill: true
  }, rest), tabs.map(function (tab, i) {
    return /*#__PURE__*/_react.default.createElement(_BaseTabs.BaseTab, {
      key: i,
      as: _Clickable.Clickable,
      ref: tab.ref,
      "aria-selected": i === activeTabIndex,
      disabled: disableNavigation || i > currentStepIndex,
      onClick: handleClick(i),
      active: i === activeTabIndex,
      variant: "sm",
      justifyContent: "flex-start"
    }, /*#__PURE__*/_react.default.createElement(_Flex.Flex, {
      alignItems: "center",
      justifyContent: "space-between",
      flex: 1
    }, /*#__PURE__*/_react.default.createElement(_Flex.Flex, {
      alignItems: "center"
    }, /*#__PURE__*/_react.default.createElement(_Box.Box, {
      color: i > currentStepIndex ? "black30" : undefined
    }, tab.child.props.name), currentStepIndex > i && /*#__PURE__*/_react.default.createElement(_CheckIcon.CheckIcon, {
      width: 16,
      height: 16,
      fill: "green100",
      ml: 1
    })), /*#__PURE__*/_react.default.createElement(_ChevronIcon.ChevronIcon, {
      fill: "black60",
      height: 10,
      ml: 1
    })));
  })), activeTab.current.child);
};
/** StepProps */


exports.Stepper = Stepper;

/**
 * An individual step.
 * Does nothing on its own; props are dealt with inside of Steps.
 */
var Step = function Step(_ref2) {
  var children = _ref2.children;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, children);
};

exports.Step = Step;
Stepper.defaultProps = {
  mb: 2
};
//# sourceMappingURL=Stepper.js.map